import React from 'react';
import AddAta from './AddAta';

export default function EditAta(props) {
  return <AddAta goTo={props.goTo} isEditing />;
}
